import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppConfigModule } from 'src/app/layout/config/app.config.module';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { HttpClientModule } from '@angular/common/http';
import { SelecionarFranquiaRoutingModule } from './selecionar-franquia-routing.module';
import { SelecionarFranquiaComponent } from './selecionar-franquia.component';
import { SelecionarFranquiaGuard } from './selecionar-franquia.guard';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@NgModule({
    imports: [
        CommonModule,
        SelecionarFranquiaRoutingModule,
        AppConfigModule,
        HttpClientModule,
        TooltipModule,
        DividerModule,
        ButtonModule,
        TableModule,
        InputTextModule,
        ProgressSpinnerModule
    ],
    declarations: [SelecionarFranquiaComponent],
    providers: [SelecionarFranquiaGuard]
})
export class SelecionarFranquiaModule { }
